import {extractFormErrorsFromResponse, putAll, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {subjectManagementFacilityFormName} from '../../types/subject-management-facility-form-values';
import {adminAction, UpdateBreederDetailAction} from '../action';
import {
    buildSubjectManagementCenterOptions,
    BuildSubjectManagementCenters,
} from './build-subject-management-center-options';

const te = t('common');
const title = te('updateEntry');

function* execute({payload}: UpdateBreederDetailAction): SagaIterator {
    const formValues = yield* select(formHelpers.formValues(subjectManagementFacilityFormName));
    yield* put(formHelpers.startSubmit(subjectManagementFacilityFormName));

    const buildFarms: BuildSubjectManagementCenters = {
        centerIds: formValues.prop('farmIds').orNull(), type: 'USERS_FARM',
    };

    const farmIds = yield* call(buildSubjectManagementCenterOptions, buildFarms);

    const response = yield* call(Api.updateUserProfileBreederRoleBySubjectManager, {
        approvedTo: formValues.prop('approvedTo').orNull(),
        farmIds,
        userProfileBreederRoleId: formValues
            .prop('userProfileRoleIds').headIn().orCrash('No userProfileRoleIds found'),
    });

    if (response.isSuccess) {
        yield* put(adminAction.getManagementBreedersTableData(opt({action: 'refresh'}), opt(payload)));
        yield* put(showSuccess(title, te('updateEntrySuccess'), false, 'updateManagementBreeder'));
        yield* put(adminAction.setManagementSubjectModalVisible(null));
        yield* put(formHelpers.reset(subjectManagementFacilityFormName));
    } else {
        yield putAll(showBeError(response, title));
        yield* put(formHelpers.stopSubmit(subjectManagementFacilityFormName, extractFormErrorsFromResponse(response)));
    }
}
/** Runs the admin saga that updates the selected breeder-management binding. */
export function* updateManagementBreederDetailSaga(): SagaIterator {
    yield takeLatestF('admin/UPDATE_BREEDER_DETAIL', execute);
}
